import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import AnalysisTabs from "examples/Tabs/AnalysisTabs";

function BranchProfit() {
  return (
    <DashboardLayout>
      <AnalysisTabs />
    </DashboardLayout>
  );
}

export default BranchProfit;